const ROOT = "buttonViewer";
const BORDER_WIDTH_INPUT = "borderWidthInput";
const BORDER_WIDTH_SLIDER = "borderWidthSlider";
const CORNER_RADIUS_INPUT = "cornerRadiusInput";
const CORNER_RADIUS_SLIDER = "cornerRadiusSlider";
const TEXT_COLOR_TOGGLE = "textColorToggle";
const BORDER_COLOR_TOGGLE = "borderColorToggle";
const BACKGROUND_COLOR_TOGGLE = "backgroundColorToggle";
const BUTTON_INPUT_MODAL = "ButtonInputModal";
const BUTTON_TEXT_INPUT = "ButtonTextInput";
const SETTINGS_TABS = "SettingsTabs";
const SETTINGS_TAB_SETTINGS = "SettingsTabSettings";
const SETTINGS_TAB_DESIGN = "SettingsTabDesign";

export { BACKGROUND_COLOR_TOGGLE, BORDER_COLOR_TOGGLE, BORDER_WIDTH_INPUT, BORDER_WIDTH_SLIDER, BUTTON_INPUT_MODAL, BUTTON_TEXT_INPUT, CORNER_RADIUS_INPUT, CORNER_RADIUS_SLIDER, ROOT, SETTINGS_TABS, SETTINGS_TAB_DESIGN, SETTINGS_TAB_SETTINGS, TEXT_COLOR_TOGGLE };
//# sourceMappingURL=dataHooks.js.map
